import {IEnquiryFormErrorMessages} from '@/dictionaries/components/enquiryForm/types';
import * as yup from 'yup';

export function getTranslatedSchema(dict: IEnquiryFormErrorMessages) {
  return yup.object().shape({
    name: yup.string().required(dict.name),
    surname: yup.string().required(dict.surname),
    country_info: yup.object().shape({
      name: yup.string().required(),
      code: yup.string().required(),
      id: yup.number().required(),
      phone: yup.object().shape({
        code: yup.number().required(),
        country: yup.string().required(),
      }),
    }),
    email: yup.string().email(dict.email).required(dict.email),
    phone: yup
      .string()
      .typeError(dict.phone.typeError)
      .required(dict.phone.required),
    dates: yup.object().shape({
      start: yup.date().default(null).nullable(),
      end: yup.date().default(null).nullable(),
    }),
    adults: yup.number().default(0),
    children: yup.number().default(0),
    infants: yup.number().default(0),
    flexible: yup.boolean().optional(),
    terms: yup.boolean().oneOf([true], dict.terms).required(dict.terms),
    note: yup.string().optional(),
  });
}

export function getBaseTranslatedSchema(dict: IEnquiryFormErrorMessages) {
  return getTranslatedSchema(dict).pick([
    'name',
    'surname',
    'email',
    'phone',
    'dates',
    'terms',
  ]);
}
